<div class="search-result-container">
    <div class="search-result-container_internal">
        <table mat-table [dataSource]="dataSource" class="content-gray">
            <ng-container matColumnDef="idUser">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let dataSearch" class="item-result-div">
                    <app-search-result-item [initialTabindex]="initialTabindex" [isSearchBar]="true" [name]="dataSearch.name" [title]="dataSearch.translationKey"
                        [description]="dataSearch.path" [url]="dataSearch.url" [id]="dataSearch.id" [typeMenu]="dataSearch.tipoMenu">
                    </app-search-result-item>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
       
       <!--
            CSCSATIVA-5524 - Desenvolvimento - Ajuste Navegação Teclado tela resultado Pesquisa "Caixa Pesquisa"
            Conforme alinhado com Patricia Moreira e validado com Willian Pimentel, paginação será retirada 
            para facilitar navegação por teclado a fim de atender o criterio acessibilidade.
       -->
        <!--<mat-paginator id="resultPaginator" [length]="paginatorLength" [pageSizeOptions]="pageSizeOptions"
        class="content-gray">
        </mat-paginator>-->
    </div>
</div>